import React from 'react';

const Step1 = ({ formData, setFormData, nextStep }) => {
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const isValid = () => {
    return formData.name && 
           formData.mobile && 
           formData.mobile.length === 10 &&
           formData.dob && 
           formData.address && 
           formData.pincode &&
           formData.pincode.length === 6;
  };

  return (
    <div className="step-container">
      <div className="step-header">
        <div className="step-number">1</div>
        <div className="step-title">
          <h3>Personal Information</h3>
          <p>Tell us about yourself</p>
        </div>
      </div>

      <div className="step-form">
        <div className="form-row">
          <div className="form-group">
            <label>Full Name *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your full name as per PAN"
              required
            />
          </div>
          <div className="form-group">
            <label>Mobile Number *</label>
            <input
              type="tel"
              name="mobile"
              value={formData.mobile}
              disabled
              className="disabled-input"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Date of Birth *</label>
            <input
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label>Residential Address *</label>
          <textarea
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="Enter your complete address"
            rows="3"
            required
          />
        </div>

        <div className="form-group">
          <label>Pin Code *</label>
          <input
            type="text"
            name="pincode"
            value={formData.pincode}
            onChange={handleChange}
            placeholder="6 digit pin code"
            maxLength="6"
            pattern="[0-9]{6}"
            required
          />
        </div>

        <div className="step-actions">
          <button onClick={nextStep} className="btn-next" disabled={!isValid()}>
            Continue to Loan Details →
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step1;